import { render, staticRenderFns } from "./CphSidebarNavigation.vue?vue&type=template&id=e3fcb5e8&scoped=true&"
import script from "./CphSidebarNavigation.vue?vue&type=script&lang=js&"
export * from "./CphSidebarNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CphSidebarNavigation.vue?vue&type=style&index=0&id=e3fcb5e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fcb5e8",
  null
  
)

export default component.exports